import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage for web

import authReducer from './slices/authSlice.web';
import timeClockReducer from './slices/timeClockSlice';
import employeeReducer from './slices/employeeSlice';
import scheduleReducer from './slices/scheduleSlice';
import timeOffReducer from './slices/timeOffSlice';
import chatReducer from './slices/chatSlice';
import notificationsReducer from './slices/notificationsSlice';
import callPerformanceReducer from './slices/callPerformanceSlice';
import callReviewReducer from './slices/callReviewSlice';
import myClassesReducer from './slices/myClassesSlice';
import staffClassesReducer from './slices/staffClassesSlice';

// Persist config for web
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // Only persist auth state
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    timeClock: timeClockReducer,
    employee: employeeReducer,
    schedule: scheduleReducer,
    timeOff: timeOffReducer,
    chat: chatReducer,
    notifications: notificationsReducer,
    callPerformance: callPerformanceReducer,
    callReview: callReviewReducer,
    myClasses: myClassesReducer,
    staffClasses: staffClassesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;